"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = exports.fireBlight = exports.walnutBlightRPV = exports.soilMAD = exports.soilFavoriteDepths = exports.plantStress = exports.irrigationFlowMeterSettings = exports.insectBiofix = exports.fruitGrowthSettings = exports.evapotranspiration = exports.emitterConfiguration = exports.bloom = exports.alternariaDSV = exports.almondHullSplit = void 0;
const zod_1 = require("zod");
const almondHullSplit_1 = require("./almondHullSplit/almondHullSplit");
const alternariaDSV_1 = require("./alternariaDSV/alternariaDSV");
const bloom_1 = require("./bloom/bloom");
const emitterConfiguration_1 = require("./emitterConfiguration/emitterConfiguration");
const evapotranspiration_1 = require("./evapotranspiration/evapotranspiration");
const fireBlight_1 = require("./fireBlight/fireBlight");
const fruitGrowthSettings_1 = require("./fruitGrowthSettings/fruitGrowthSettings");
const insectBiofix_1 = require("./insectBiofix/insectBiofix");
const irrigationFlowMeterSettings_1 = require("./irrigationFlowMeterSettings/irrigationFlowMeterSettings");
const plantStress_1 = require("./plantStress/plantStress");
const soilFavoriteDepths_1 = require("./soilFavoriteDepths/soilFavoriteDepths");
const soilMAD_1 = require("./soilMAD/soilMAD");
const walnutBlightRPV_1 = require("./walnutBlightRPV/walnutBlightRPV");
/* eslint-disable padding-line-between-statements */
exports.almondHullSplit = __importStar(require("./almondHullSplit/almondHullSplit"));
exports.alternariaDSV = __importStar(require("./alternariaDSV/alternariaDSV"));
exports.bloom = __importStar(require("./bloom/bloom"));
exports.emitterConfiguration = __importStar(require("./emitterConfiguration/emitterConfiguration"));
exports.evapotranspiration = __importStar(require("./evapotranspiration/evapotranspiration"));
exports.fruitGrowthSettings = __importStar(require("./fruitGrowthSettings/fruitGrowthSettings"));
exports.insectBiofix = __importStar(require("./insectBiofix/insectBiofix"));
exports.irrigationFlowMeterSettings = __importStar(require("./irrigationFlowMeterSettings/irrigationFlowMeterSettings"));
exports.plantStress = __importStar(require("./plantStress/plantStress"));
exports.soilFavoriteDepths = __importStar(require("./soilFavoriteDepths/soilFavoriteDepths"));
exports.soilMAD = __importStar(require("./soilMAD/soilMAD"));
exports.walnutBlightRPV = __importStar(require("./walnutBlightRPV/walnutBlightRPV"));
/* eslint-enable padding-line-between-statements */
exports.fireBlight = __importStar(require("./fireBlight/fireBlight"));
exports.requestSchema = zod_1.z.object({
    almondHullSplitUpdate: almondHullSplit_1.almondHullSplitUpdate.requestSchema.optional(),
    alternariaDSVUpdate: alternariaDSV_1.alternariaDSVUpdate.requestSchema.optional(),
    bloomUpdate: bloom_1.bloomUpdate.requestSchema.optional(),
    emitterConfigurationUpdate: emitterConfiguration_1.emitterConfigurationUpdate.requestSchema.optional(),
    fireBlightUpdate: fireBlight_1.fireBlightUpdate.requestSchema.optional(),
    fruitGrowthSettingsDelete: fruitGrowthSettings_1.fruitGrowthSettingsDelete.requestSchema.optional(),
    fruitGrowthSettingsUpdate: fruitGrowthSettings_1.fruitGrowthSettingsUpdate.requestSchema.optional(),
    irrigationFlowMeterSettingsUpdate: irrigationFlowMeterSettings_1.irrigationFlowMeterSettingsUpdate.requestSchema.optional(),
    insectBiofixCreate: insectBiofix_1.insectBiofixCreate.requestSchema.optional(),
    insectBiofixDelete: insectBiofix_1.insectBiofixDelete.requestSchema.optional(),
    insectBiofixUpdate: insectBiofix_1.insectBiofixUpdate.requestSchema.optional(),
    kcModelBlockUpdate: evapotranspiration_1.kcModelBlockUpdate.requestSchema.optional(),
    kcModelDelete: evapotranspiration_1.kcModelDelete.requestSchema.optional(),
    kcModelUpsert: evapotranspiration_1.kcModelUpsert.requestSchema.optional(),
    plantStressDelete: plantStress_1.plantStressDelete.requestSchema.optional(),
    plantStressUpdate: plantStress_1.plantStressUpdate.requestSchema.optional(),
    soilFavoriteDepths: soilFavoriteDepths_1.requestSchema.optional(),
    soilMADCreate: soilMAD_1.soilMADCreate.requestSchema.optional(),
    soilMADDelete: soilMAD_1.soilMADDelete.requestSchema.optional(),
    soilMADUpdate: soilMAD_1.soilMADUpdate.requestSchema.optional(),
    walnutBlightRPVCreate: walnutBlightRPV_1.walnutBlightRPVCreate.requestSchema.optional(),
    walnutBlightRPVUpdate: walnutBlightRPV_1.walnutBlightRPVUpdate.requestSchema.optional(),
});
exports.path = '/field-asset-settings-set';
//# sourceMappingURL=index.js.map